import React, { useEffect, useState } from 'react'
import { Button, FormSectionTitle, makeStyles, Grid } from '@paintscout/ui'
import { FormSection } from '@paintscout/ui-business'
import type { QuoteDocument, OptionsDocument } from 'paintscout'
import type { BulkEditDetails, BulkOperation } from '@paintscout/util/builder'
import { uuid } from '@paintscout/util/builder'
import ProductSection from './ProductSection'
import AddRemoveSection from './AddRemoveSection'

const useStyles = makeStyles((theme) => ({
  root: {},
  form: {
    paddingTop: 0,
    overflow: 'hidden'
  },
  rateContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingLeft: '0.5em'
  },
  editItemSection: {
    alignItems: 'center',
    margin: '0.5em 0em 0.5em 0',
    backgroundColor: theme.paintscout.palette.brand.Neutral.P94
  },
  dropdown: {
    width: '9em',
    marginBottom: '0.5em',
    color: 'white'
  },
  locationsGrid: {
    marginBottom: '1em'
  },
  addSectionButton: {
    marginTop: '1em'
  },
  titleContainer: {
    display: 'flex',
    width: '100%'
  }
}))

export interface EditBulkDetailsFormProps {
  quote: QuoteDocument
  options: OptionsDocument
  bulkDetails: BulkEditDetails
  keys: string[]
  handleUpdateOperations: (updatedOperationsList: BulkOperation[]) => void
}

function EditBulkDetailsForm(props: EditBulkDetailsFormProps) {
  const { quote, options, handleUpdateOperations, bulkDetails } = props
  const classes = useStyles(props)
  const [operationsList, setOperationsList] = useState<BulkOperation[]>([])
  const [sectionCount, setSectionCount] = useState([])

  // Take operation from form field, add it to operationsList
  const upsertOperation = (operation: BulkOperation) => {
    let operationPresent = false
    const newOperationsList = operationsList.map((op) => {
      if (op.key === operation.key) {
        operationPresent = true
        return operation
      } else {
        return op
      }
    })

    if (operationPresent) {
      setOperationsList(newOperationsList)
    } else {
      newOperationsList.push(operation)
      setOperationsList(newOperationsList)
    }
  }

  const handleProductChange = upsertOperation

  const handleActionChange = upsertOperation

  // Pass our updated operationsList to our outer list in dialog
  useEffect(() => {
    handleUpdateOperations(operationsList)
  }, [operationsList])
  const checkParentHasChanges = () => operationsList.length > 0

  return (
    <div className={classes.root}>
      <FormSection hideDivider={true} className={classes.form}>
        {bulkDetails.uniqueProducts && (
          <>
            <FormSectionTitle title={'Products'} variant={'h1'} />
            <Grid container={true} spacing={3} className={classes.rateContainer}>
              {bulkDetails.uniqueProducts.map((product, i) => {
                return (
                  <ProductSection
                    key={i}
                    quote={quote}
                    bulkDetails={bulkDetails}
                    options={options}
                    product={product}
                    handleProductChange={handleProductChange}
                    checkParentHasChanges={checkParentHasChanges}
                  />
                )
              })}
            </Grid>
          </>
        )}

        {/* Add/Remove Sections */}
        <FormSectionTitle style={{ marginTop: '0.5em' }} title={'Add/Remove'} variant={'h1'} />
        <Grid container={true} spacing={3} className={classes.rateContainer}>
          {sectionCount.map((section) => {
            return (
              <AddRemoveSection
                key={section}
                id={section}
                quote={quote}
                bulkDetails={bulkDetails}
                options={options}
                handleActionChange={handleActionChange}
                checkParentHasChanges={checkParentHasChanges}
                handleSectionClose={(key) => {
                  console.log('HER !', key)
                  console.log('HER !', sectionCount)
                  setSectionCount((sectionCount) => sectionCount.filter((s) => s !== key))
                }}
              />
            )
          })}
        </Grid>
        <Button
          className={classes.addSectionButton}
          onClick={() => setSectionCount((sectionCount) => [...sectionCount, uuid()])}
        >
          +
        </Button>
      </FormSection>
    </div>
  )
}

export default EditBulkDetailsForm
